export const TAG_GET_LIST = 'TAG_GET_LIST';
export const TAG_GET_LIST_OK = 'TAG_GET_LIST_OK';
export const TAG_GET_LIST_FAIL = 'TAG_GET_LIST_FAIL';
